import Service from '@ember/service';

export default class VaConfigService extends Service {}
